import { projectIdFromSearch, seedBlankStudioSession } from './studioPersist';
import { forkIdFromSearch } from './guestFork';

export type StudioEntry = 'studio' | 'chooser' | 'wait';

export const BLANK_PLAYBOOK = {
  title: 'Untitled playbook',
  outcome_description: 'Describe the outcome in chat.',
  outcome_type: 'workflow',
};

export function studioEntry(opts: {
  loggedIn: boolean;
  projectId: string | null;
  forkId: string | null;
  projectsKnown: boolean;
}): StudioEntry {
  if (!opts.loggedIn || opts.projectId || opts.forkId) return 'studio';
  if (!opts.projectsKnown) return 'wait';
  return 'chooser';
}

export function studioEntryFromSearch(search: string, loggedIn: boolean, projectsKnown: boolean): StudioEntry {
  return studioEntry({
    loggedIn,
    projectId: projectIdFromSearch(search),
    forkId: forkIdFromSearch(search),
    projectsKnown,
  });
}

export function seedStudioChatTab(
  projectId: string,
  storage: { setItem(key: string, value: string): void } = localStorage,
): void {
  seedBlankStudioSession(projectId, storage);
}

export function studioProjectPath(projectId: string): string {
  return `/compose?project=${encodeURIComponent(projectId)}`;
}

export async function startNewPlaybook(opts: {
  create: (p: typeof BLANK_PLAYBOOK) => Promise<{ id: string } & Record<string, unknown>>;
  seedTab?: (projectId: string) => void;
  navigate: (path: string, extras?: { state?: unknown }) => void;
}): Promise<{ ok: boolean; error?: string }> {
  try {
    const created = await opts.create(BLANK_PLAYBOOK);
    opts.seedTab?.(created.id);
    opts.navigate(studioProjectPath(created.id), { state: { project: created } });
    return { ok: true };
  } catch (err: unknown) {
    return { ok: false, error: err instanceof Error ? err.message : 'failed to create playbook' };
  }
}
